import vidmetrics from "../assets/images/vidmetrics-project.jpg";
import nimbus from "../assets/images/nimbus.png";
import kiosk from "../assets/images/kioskhive-project.jpg";
import store from "../assets/images/jay-store-project.jpg";
import pulse from "../assets/images/live-pulse-project.jpg";
import { AdditionalProject } from "../types/project";
export const additional: AdditionalProject[] = [
  {
    name: "Kioskhive",
    category: "B2B marketplace",
    summary:
      "Backend API work with Laravel for a marketplace connecting local brands and retailers.",
    live: "https://kioskhiveng.vercel.app/",
    tags: ["Laravel", "REST APIs"],
    image: kiosk,
  },
  {
    name: "Live Pulse",
    category: "Shared sessions",
    summary:
      "Temporary group rooms with shared sessions, location interactions, and server-issued credentials.",
    live: "https://pulse-assessment-mocha.vercel.app/",
    tags: ["Web application"],
    image: pulse,
  },
  {
    name: "VidMetrics",
    category: "Video analytics",
    summary:
      "A dashboard for exploring video analytics and competitor channel performance.",
    live: "https://vidmetric-rho.vercel.app/",
    tags: ["Next.js", "TypeScript"],
    image: vidmetrics,
  },
  {
    name: "Aura Nimbus",
    category: "Interactive commerce",
    summary:
      "An interactive keyboard storefront exploring 3D product presentation.",
    live: "https://nimbus-keyboards-demo.vercel.app/",
    tags: ["Next.js", "Three.js"],
    image: nimbus,
  },
  {
    name: "Jay Store",
    category: "E-commerce",
    summary:
      "A React storefront with product filtering, pagination, and shopping-cart interactions.",
    live: "https://fabjay-shop.vercel.app/",
    tags: ["React", "Redux"],
    image: store,
  },
];
